var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,7.3C38,2.6,31.7,0,25.1,0C11.4,0,0.3,11.1,0.3,24.8c0,4.4,1.1,8.6,3.3,12.4L0.1,50l13.1-3.4 c3.6,2,7.7,3,11.8,3h0h0c13.7,0,24.8-11.1,24.8-24.8C49.9,18.2,47.3,11.9,42.6,7.3L42.6,7.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1039,
    y1: 45.3865,
    x2: 25.1039,
    y2: 4.1848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20B038"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#60D66A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1,45.4L25.1,45.4c-3.7,0-7.3-1-10.5-2.9l-0.8-0.4l-7.8,2l2.1-7.6l-0.5-0.8c-2.1-3.3-3.2-7.1-3.1-11 c0-11.4,9.2-20.6,20.6-20.6c5.5,0,10.7,2.1,14.6,6c3.9,3.9,6,9.1,6,14.6C45.7,36.1,36.5,45.4,25.1,45.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.9,14.4c-0.5-1-1-1.1-1.4-1.1c-0.4,0-0.8,0-1.2,0c-0.4,0-1.1,0.2-1.7,0.8c-0.6,0.6-2.2,2.1-2.2,5.2 c0,3,2.2,6,2.5,6.4c0.3,0.4,4.3,6.9,10.6,9.3c5.2,2.1,6.3,1.7,7.4,1.5c1.1-0.1,3.7-1.5,4.2-2.9c0.5-1.4,0.5-2.7,0.4-2.9 c-0.2-0.3-0.6-0.4-1.2-0.7s-3.7-1.8-4.2-2c-0.6-0.2-1-0.3-1.4,0.3c-0.4,0.6-1.6,2-2,2.4c-0.4,0.4-0.7,0.5-1.3,0.2 c-0.6-0.3-2.6-1-5-3.1c-1.8-1.6-3.1-3.7-3.4-4.3c-0.4-0.6,0-1,0.3-1.3c0.3-0.3,0.6-0.7,0.9-1.1c0.3-0.4,0.4-0.6,0.6-1 c0.2-0.4,0.1-0.8-0.1-1.1S19.5,15.6,18.9,14.4L18.9,14.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,7.3C38,2.6,31.7,0,25.1,0C11.4,0,0.3,11.1,0.3,24.8c0,4.4,1.1,8.6,3.3,12.4L0.1,50l13.1-3.4 c3.6,2,7.7,3,11.8,3h0h0c13.7,0,24.8-11.1,24.8-24.8C49.9,18.2,47.3,11.9,42.6,7.3L42.6,7.3z M25.1,45.4L25.1,45.4 c-3.7,0-7.3-1-10.5-2.9l-0.8-0.4l-7.8,2l2.1-7.6l-0.5-0.8c-2.1-3.3-3.2-7.1-3.1-11c0-11.4,9.2-20.6,20.6-20.6 c5.5,0,10.7,2.1,14.6,6c3.9,3.9,6,9.1,6,14.6C45.7,36.1,36.5,45.4,25.1,45.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.b317705ee8611c47d54331844c1ac90d.svg";
export { ForwardRef as ReactComponent };